import React from 'react';

const steps = [
  { num: "1", title: "Assessment", desc: "Free eligibility & exemption check for your business.", tag: "1-2 DAYS" },
  { num: "2", title: "Compliance Advisory", desc: "Guidance on your corporate tax obligations & process.", tag: "1-2 WEEKS" },
  { num: "3", title: "Return Preparation", desc: "Accurate preparation & review of your return, ready for submission.", tag: "ONGOING" },
  { num: "4", title: "Ongoing Advisory", desc: "Year-round compliance support and deadline tracking.", tag: "24/7" },
];

const ProcessSection = () => {
  return (
    <section data-screen-label="Process" style={{ padding: 'clamp(40px, 4.5vw, 64px) clamp(16px, 4vw, 48px)', background: '#F3F0E7', textAlign: 'left' }}>
      <div
        style={{
          maxWidth: '1120px',
          margin: '0 auto',
          display: 'flex',
          flexDirection: 'column',
          gap: '36px',
          alignItems: 'center',
        }}
      >
        <div style={{ textAlign: 'center', display: 'flex', flexDirection: 'column', gap: '10px', alignItems: 'center' }}>
          <span
            style={{
              fontSize: '11px',
              fontWeight: 800,
              letterSpacing: '2px',
              color: '#B5652E',
              border: '1px solid #E1C6A3',
              borderRadius: '999px',
              padding: '5px 14px',
              background: '#FBFAF6',
            }}
          >
            PROCESS DRIVEN
          </span>
          <h2 style={{ fontFamily: "'Montserrat', sans-serif", fontSize: 'clamp(22px, 4vw, 32px)', color: '#26332C', margin: 0, fontWeight: 800 }}>
            Built to Keep You Compliant
          </h2>
          <p style={{ margin: 0, fontSize: '15px', color: '#5C574C', maxWidth: '58ch', textAlign: 'center' }}>
            Every step is handled by certified tax professionals who keep your business ahead of deadlines, errors, and regulatory curveballs.
          </p>
        </div>

        <div className="process-grid">
          {steps.map((step) => (
            <div
              key={step.num}
              style={{
                background: '#FBFAF6',
                border: '1px solid #E4DCCC',
                borderRadius: '14px',
                padding: '26px 20px',
                display: 'flex',
                flexDirection: 'column',
                gap: '10px',
                textAlign: 'center',
                alignItems: 'center',
              }}
            >
              <div
                style={{
                  width: '44px',
                  height: '44px',
                  borderRadius: '12px',
                  background: '#EFE0CC',
                  color: '#B5652E',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontFamily: "'Montserrat', sans-serif",
                  fontWeight: 800,
                  fontSize: '17px',
                }}
              >
                {step.num}
              </div>
              <div style={{ fontFamily: "'Montserrat', sans-serif", fontSize: '16px', fontWeight: 700, color: '#26332C' }}>
                {step.title}
              </div>
              <div style={{ fontSize: '13.5px', lineHeight: 1.5, color: '#5C574C' }}>
                {step.desc}
              </div>
              <div
                style={{
                  marginTop: 'auto',
                  fontSize: '11px',
                  fontWeight: 800,
                  letterSpacing: '1px',
                  color: '#B5652E',
                  background: '#F8EBD9',
                  borderRadius: '999px',
                  padding: '4px 12px',
                }}
              >
                {step.tag}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
